import { render, staticRenderFns } from "./MakeADonation.vue?vue&type=template&id=36535ba8&scoped=true&"
import script from "./MakeADonation.vue?vue&type=script&lang=js&"
export * from "./MakeADonation.vue?vue&type=script&lang=js&"
import style0 from "./MakeADonation.vue?vue&type=style&index=0&id=36535ba8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36535ba8",
  null
  
)

export default component.exports